import { useEffect, useRef } from 'react';
import { useStoreApi } from '@tmsw/powerups.store';
import { useTranslate } from '@tmsw/powerups.intl.legacy.hooks.use-translate';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';
import { SrOnly } from '@tmsw/powerups.ui.a11y.sr-only';

export type HiddenH1Props = {
  gameCharacter?: string;
};
export function HiddenH1({ gameCharacter }: HiddenH1Props) {
  const translate = useTranslate();
  const { subscribe, getState } = useStoreApi();
  const { getPageKey } = usePageConfig();
  const pageRef = useRef(getState().currentPage);
  const pageNameRef = useRef(getPageKey(pageRef.current));
  const headerTextRef = useRef(
    translate('hiddenH1', pageNameRef.current as any)
  );
  const upperCaseGameCharacter = gameCharacter
    ? gameCharacter.charAt(0).toUpperCase() + gameCharacter?.slice(1)
    : '';
  console.log(upperCaseGameCharacter);

  useEffect(() => {
    const pageChangeUnsub = subscribe(
      (state: any) => state.currentPage,
      (curr: any) => {
        pageRef.current = curr;
        pageNameRef.current = getPageKey(pageRef.current);
        headerTextRef.current = translate(
          'hiddenH1',
          pageNameRef.current as any
        );
        console.log(
          'HiddenH1',
          pageRef.current,
          pageNameRef.current,
          headerTextRef.current
        );
      }
    );
    return () => {
      pageChangeUnsub();
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [subscribe]);

  return headerTextRef.current ? (
    <SrOnly as="h1" tabIndex={-1}>
      {headerTextRef.current?.replace(
        '{{gameCharacter}}',
        upperCaseGameCharacter
      )}
    </SrOnly>
  ) : null;
}
